/**
 * Breadcrumb - Componente de navegación para la vista de detalle de Factura
 *
 * Muestra el breadcrumb con la estructura: Facturación > Facturas > [Código]
 * El código de la factura se muestra dinámicamente según la factura actual.
 */
import { usePageNavigation } from '@shared/components/navigation/usePageNavigation';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface BreadcrumbProps {
  /** Código de la factura (ej. "FAC-8752") */
  invoiceCode?: string;
}

export const Breadcrumb = ({ invoiceCode }: BreadcrumbProps) => {
  const { t } = useTranslation('invoicesViewModule');

  const breadcrumbs = useMemo(
    () => [
      { label: t('breadcrumb.invoices', 'Facturación') },
      {
        label: t('breadcrumb.invoicesList', 'Facturas'),
        path: '/invoices',
      },
      {
        label: <span className="text-title">{invoiceCode || t('breadcrumb.loading', 'Cargando...')}</span>,
        _key: invoiceCode ?? 'loading',
      },
    ],
    [t, invoiceCode],
  );

  usePageNavigation({ breadcrumbs });

  return null;
};
